import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type Compensation from 'modules/contracts/store/models/Compensation'

import SupplementsSettings from './SupplementsSettings'
import { FormSection } from './_FormSection'

interface Props {
  form: Form
  compensation: Compensation
  isEditable: boolean
  renderRecurrence: () => React.ReactNode
  renderFirstPaymentOn: () => React.ReactNode
}

const Schedule = ({
  form,
  compensation,
  isEditable,
  renderRecurrence,
  renderFirstPaymentOn,
}: Props) => {
  const renderRecurrenceFieldsForPayrollPolicies = () => {
    if (form.get('sync_with_supplements').value) {
      return <SupplementsSettings compensation={compensation} isEditable={isEditable} form={form} />
    }

    return (
      <>
        <Box>{renderRecurrence()}</Box>
        <Box>{renderFirstPaymentOn()}</Box>
      </>
    )
  }

  return (
    <FormSection
      header={i18n.t('contract_versions.forms.additional_compensation.modal.section2_header')}
    >
      {renderRecurrenceFieldsForPayrollPolicies()}
    </FormSection>
  )
}

export default observer(Schedule)
